import { render } from "./PosReceiptSettings.vue?vue&type=template&id=604d8db6&scoped=true&ts=true"
import script from "./PosReceiptSettings.vue?vue&type=script&lang=ts"
export * from "./PosReceiptSettings.vue?vue&type=script&lang=ts"

import "./PosReceiptSettings.vue?vue&type=style&index=0&id=604d8db6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604d8db6"]])

export default __exports__